function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 25,
  cy: 25,
  r: 25
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  x: 14.7058824,
  y: 10.5882353,
  width: 20.5882353,
  height: 28.8235294,
  rx: 2
}), /*#__PURE__*/React.createElement("filter", {
  x: "-111.7%",
  y: "-55.5%",
  width: "323.4%",
  height: "259.6%",
  filterUnits: "objectBoundingBox",
  id: "filter-4"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.239215686   0 0 0 0 0.335551213   0 0 0 0 0.941176471  0 0 0 0.525158435 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Patient-Portal-Signed-In-//-Dashboard",
  transform: "translate(-1036.000000, -399.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(926.000000, 166.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(0.000000, 213.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(110.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  fill: "#AEB8FF",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.4085614,12.432375 L38.6438555,12.432375 C39.748425,12.432375 40.6438555,13.3278055 40.6438555,14.432375 L40.6438555,35.7264927 C40.6438555,36.8310622 39.748425,37.7264927 38.6438555,37.7264927 L24.4085614,37.7264927 C23.3039919,37.7264927 22.4085614,36.8310622 22.4085614,35.7264927 L22.4085614,14.432375 C22.4085614,13.3278055 23.3039919,12.432375 24.4085614,12.432375 Z",
  id: "Rectangle-Copy",
  fill: "#FFFFFF",
  opacity: 0.800000012,
  mask: "url(#mask-2)",
  transform: "translate(31.526208, 25.079434) rotate(20.000000) translate(-31.526208, -25.079434) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4673849,12.432375 L25.702679,12.432375 C26.8072485,12.432375 27.702679,13.3278055 27.702679,14.432375 L27.702679,35.7264927 C27.702679,36.8310622 26.8072485,37.7264927 25.702679,37.7264927 L11.4673849,37.7264927 C10.3628154,37.7264927 9.4673849,36.8310622 9.4673849,35.7264927 L9.4673849,14.432375 C9.4673849,13.3278055 10.3628154,12.432375 11.4673849,12.432375 Z",
  id: "Rectangle-Copy-2",
  fill: "#FFFFFF",
  opacity: 0.800000012,
  mask: "url(#mask-2)",
  transform: "translate(18.585032, 25.079434) scale(-1, 1) rotate(20.000000) translate(-18.585032, -25.079434) "
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-4)",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3D56F0",
  mask: "url(#mask-2)",
  x: 18.8235294,
  y: 14.7058824,
  width: 12.3529412,
  height: 2.94117647,
  rx: 1.47058824
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  fill: "#00D9CD",
  mask: "url(#mask-2)",
  x: 18.8235294,
  y: 26.4705882,
  width: 12.3529412,
  height: 2.94117647,
  rx: 1.47058824
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fill: "#3D56F0",
  opacity: 0.400000006,
  mask: "url(#mask-2)",
  x: 18.8235294,
  y: 31.1764706,
  width: 12.3529412,
  height: 2.94117647,
  rx: 1.47058824
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  fill: "#3D56F0",
  mask: "url(#mask-2)",
  x: 21.7647059,
  y: 19.4117647,
  width: 6.47058824,
  height: 2.94117647,
  rx: 1.47058824
}))))));

var SvgDocumentIcon = function SvgDocumentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document-icon.985f7848.svg";
export { ForwardRef as ReactComponent };